"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _default = _propTypes.default.shape({
  all: _propTypes.default.func.isRequired,
  byId: _propTypes.default.func.isRequired
});

exports.default = _default;
module.exports = exports.default;